import {
  signInWithPopup,
  GoogleAuthProvider,
  signInWithEmailAndPassword,
  signOut,
  browserPopupRedirectResolver,
} from "firebase/auth";
import { DINECENTRAL_AUTH } from "./Firebase.dinecentral";
import { processFirebaseError } from "./components/SignIn";

export const SignInWithGoogleDineCentral = (redirectUrl: string): Promise<string> => {
  const provider = new GoogleAuthProvider();
  provider.addScope("profile");
  provider.addScope("email");

  return signInWithPopup(DINECENTRAL_AUTH, provider, browserPopupRedirectResolver)
    .then(() => "SUCCESS")
    .catch((error) => "ERROR: " + processFirebaseError(error.message));
};

export const SignInWithEmailDineCentral = (
  email: string,
  password: string
): Promise<string> => {
  return signInWithEmailAndPassword(DINECENTRAL_AUTH, email, password)
    .then((result) => {
      if (!result.user.emailVerified) return "NOT_VERIFIED";
      return "SUCCESS";
    })
    .catch((error) => "ERROR: " + processFirebaseError(error.message));
};

export const SignOutDineCentral = (redirect = "/login") => {
  signOut(DINECENTRAL_AUTH).then(() => {
    window.location.href = redirect;
  });
};